import {
  Badge,
  Box,
  Button,
  ComboboxItem,
  Flex,
  Grid,
  Group,
  NumberInput,
  rem,
  Select,
  SelectProps,
  Text,
  TextInput,
} from "@mantine/core";
import { DatePickerInput } from "@mantine/dates";
import { useDebouncedState, useDisclosure } from "@mantine/hooks";
import {
  IconAdjustmentsHorizontal,
  IconBrandBootstrap,
  IconCalendar,
  IconCalendarCog,
  IconCalendarDown,
  IconCalendarUp,
  IconCheck,
  IconFileExport,
  IconLocationFilled,
  IconSearch,
  IconUsers,
} from "@tabler/icons-react";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_RowSelectionState,
  useMantineReactTable,
} from "mantine-react-table";
import * as React from "react";
import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import {
  _timerDelayClick,
  repositoryMdm,
} from "../../../_base/_const/_constVar";
import _breadcrumb from "../../../_base/component/_layout/_breadcrumb";
import { paginationBase } from "../../../_base/model/_base/BaseTable";
import {
  formatDateNotTimeZone,
  formatDateTime,
  formatDateTransfer,
} from "../../../common/FormatDate/FormatDate";
import LoadingOverlayCustom from "../../../common/LoadingOverLayCustom/LoadingOverLayCustom";
import { BASE_API_MDM } from "../../../config";
import { _localization } from "../../../config/location";
import { green, teal } from "../../../const/variables";
import { MessageResponse } from "../../../model/MessageResponse";
import { TblDMExpense } from "../../../model/TblDMExpense";
import {
  getBranchSelectMdm,
  getTblDmProcessingMethodSelect,
} from "../../../service/getSelectApi";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";

type ColumnPinningType = {
  left?: string[];
  right?: string[];
};

const RequestFormReport = () => {
  //data and fetching state
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [data, setData] = useState<TblDMExpense[]>([]);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [height, setHeight] = useState(0);
  //table state
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  // const [keySearch, setKeySearch] = useState<string>("");
  const [selectIds, setSelectIds] = useState<string[]>([]);
  const [deleteViewStatus, setDeleteViewStatus] = useState(false);
  const [pagination, setPagination] = useState(paginationBase);
  //count
  const [timeLeft, setTimeLeft] = useState(60);
  const [isCounting, setIsCounting] = useState(false);
  //select
  const [dataTblBranch, setDataTblBranch] = useState<ComboboxItem[]>([]);
  const [dataTblProcessingMethod, setDataTblProcessingMethod] = useState<
    ComboboxItem[]
  >([]);
  const [dataWarrantyCustomerGroup, setDataWarrantyCustomerGroup] = useState<
    ComboboxItem[]
  >([]);
  //search
  const location = useLocation();
  const _searchJson = sessionStorage.getItem(String(location.pathname))
    ? JSON.parse(sessionStorage.getItem(String(location.pathname)) ?? "")
    : null;
  const checkedPinSearch = localStorage.getItem("checkedPinSearch") == "true";

  const [search, setSearch] = useState<any>({
    startDate:
      _searchJson && checkedPinSearch
        ? _searchJson?.startDate
        : new Date(
            new Date(new Date().setMonth(new Date().getMonth() - 1)).getTime() +
              7 * 60 * 60 * 1000,
          )?.toISOString(),
    endDate:
      _searchJson && checkedPinSearch
        ? _searchJson?.endDate
        : new Date(new Date().getTime() + 7 * 60 * 60 * 1000)?.toISOString(),
    status: _searchJson && checkedPinSearch ? _searchJson?.status : "",
    processingMethod:
      _searchJson && checkedPinSearch ? _searchJson?.processingMethod : "",
    customerGroup:
      _searchJson && checkedPinSearch ? _searchJson?.customerGroup : "",
    branch: _searchJson && checkedPinSearch ? _searchJson?.branch : "",
    outDate: _searchJson && checkedPinSearch ? _searchJson?.outDate : "",
    itemStatus: _searchJson && checkedPinSearch ? _searchJson?.itemStatus : "",
  });

  const fromValue = useRef<number>(0);
  const toValue = useRef<number>(0);

  const [keySearch, setKeySearch] = useDebouncedState<string>(
    _searchJson && checkedPinSearch ? _searchJson?.keySearch : "",
    300,
  );
  const [visible, { toggle, close, open }] = useDisclosure(false);

  const columns = React.useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        accessorKey: "STT",
        header: "STT",
        Cell: ({ row }) => (
          <Text fw={500} size="12.5px">
            {row.index === -1 ? "" : row.index + 1}
          </Text>
        ),
        size: 50,
        enableResizing: false,
      },
      {
        accessorKey: "branchCode",
        header: "Mã chi nhánh",
        size: 175,
      },
      {
        accessorKey: "branchName",
        header: "Chi nhánh",
      },
      {
        accessorKey: "requestNum",
        header: "Phiếu yêu cầu xử lý",
        Cell: ({ renderedCellValue, row }) => (
          <Badge
            radius="sm"
            variant="dot"
            size="lg"
            style={{ cursor: "pointer" }}
            color={renderedCellValue === null ? "red" : green.base}
          >
            {renderedCellValue === null ? null : renderedCellValue}
          </Badge>
        ),
        size: 200,
      },
      {
        accessorKey: "createDate",
        header: "Ngày tiếp nhận",
        Cell: ({ renderedCellValue }: any) => (
          <Text size="12.5px" fw={"500"}>
            {renderedCellValue && formatDateTransfer(renderedCellValue)}
          </Text>
        ),
      },
      {
        accessorKey: "entryDate",
        header: "Ngày hẹn trả",
        Cell: ({ renderedCellValue, row }: any) =>
          renderedCellValue !== null ? (
            <Badge
              color={
                row.original.serialStatus !== "Trả khách" &&
                row.original.itemStatus !== "TRA_KHACH"
                  ? getDaysDifference(renderedCellValue) <= -3
                    ? "blue"
                    : getDaysDifference(renderedCellValue) > -3 &&
                        getDaysDifference(renderedCellValue) <= 0
                      ? "yellow"
                      : "red"
                  : "green"
              }
            >
              {renderedCellValue && formatDateTime(renderedCellValue)}
            </Badge>
          ) : (
            <></>
          ),
      },
      {
        accessorKey: "customerGroupName",
        header: "Nhóm khách hàng",
      },
      {
        accessorKey: "custMeeting",
        header: "Khách hàng hẹn gặp",
        size: 200,
      },
      {
        accessorKey: "custPhone",
        header: "Số điện thoại",
      },
      {
        accessorKey: "meetingAddress",
        header: "Địa chỉ hẹn gặp",
        size: 400,
        Cell: ({ renderedCellValue }) => {
          if (renderedCellValue?.toString()?.trim()?.startsWith("-")) {
            return (
              <Text fw={500} size="12.5px">
                {renderedCellValue?.toString()?.trim()?.slice(1)}
              </Text>
            );
          }
          return (
            <Text fw={500} size="12.5px">
              {renderedCellValue?.toString()}
            </Text>
          );
        },
      },
      {
        accessorKey: "serial",
        header: "Serial",
      },
      {
        accessorKey: "itemCode",
        header: "Mã sản phẩm BH",
        Cell: ({ renderedCellValue, row }: any) =>
          renderedCellValue === null ? null : (
            <Badge variant="light">{renderedCellValue}</Badge>
          ),
      },
      {
        accessorKey: "itemName",
        header: "Sản phẩm BH",
        size: 400,
      },
      {
        accessorKey: "buyingDate",
        header: "Ngày xuất bán",
        Cell: ({ renderedCellValue }: any) => (
          <Text size="12.5px" fw={"500"}>
            {renderedCellValue && formatDateTransfer(renderedCellValue)}
          </Text>
        ),
      },
      {
        accessorKey: "listErrorCode",
        header: "Ghi nhận lỗi ban đầu",
        size: 225,
      },
      {
        accessorKey: "conclusionError",
        header: "Diễn giải",
      },
      {
        accessorKey: "resolution",
        header: "Cách khác phục",
      },
      {
        accessorKey: "itemStatus",
        header: "Trạng thái xử lý",
        Cell: ({ renderedCellValue }) => (
          <Text fw={500} size="12.5px">
            {renderedCellValue === "NHAP_KHO" ? "Nhập kho" : "Trả khách"}
          </Text>
        ),
      },
      {
        accessorKey: "processingMethodName",
        header: "Hình thức xử lý",
        Cell: ({ renderedCellValue, row }) => (
          <Badge
            color={getColorProcessingMethod(row.original?.processingMethodName)}
          >
            {renderedCellValue}
          </Badge>
        ),
      },
      {
        accessorKey: "serialStatus",
        header: "Tình trạng",
      },
      {
        accessorKey: "debtStatus",
        header: "Trạng thái trả khách",
        size: 225,
      },
      {
        accessorKey: "errorNumber",
        header: "Phiếu tiếp nhận hàng lỗi",
        Cell: ({ renderedCellValue, row }) => (
          <Badge
            radius="sm"
            variant="dot"
            size="lg"
            style={{ cursor: "pointer" }}
            color={renderedCellValue === null ? "red" : green.base}
          >
            {renderedCellValue === null ? "Chưa tiếp nhận" : renderedCellValue}
          </Badge>
        ),
        size: 225,
      },
      {
        accessorKey: "meetingDate",
        header: "Ngày hẹn xử lý",
        Cell: ({ renderedCellValue }: any) => (
          <Text size="12.5px" fw={"500"}>
            {renderedCellValue && formatDateTransfer(renderedCellValue)}
          </Text>
        ),
      },
      {
        accessorKey: "handleDate",
        header: "Ngày xử lý",
        Cell: ({ renderedCellValue }: any) => (
          <Text size="12.5px" fw={"500"}>
            {renderedCellValue && formatDateTransfer(renderedCellValue)}
          </Text>
        ),
      },
      {
        accessorKey: "attribute2",
        header: "Khách hẹn xử lý",
        Cell: ({ renderedCellValue }) => (
          <Text fw={500} size="12.5px">
            {renderedCellValue} ngày
          </Text>
        ),
      },
      {
        accessorKey: "amountReturnDate",
        header: "Số ngày hẹn trả",
        Cell: ({ renderedCellValue }) => (
          <Text fw={500} size="12.5px">
            {renderedCellValue} ngày
          </Text>
        ),
      },
      {
        accessorKey: "attribute1",
        header: "Số ngày tiếp nhận",
        Cell: ({ renderedCellValue }) => (
          <Text fw={500} size="12.5px">
            {renderedCellValue} ngày
          </Text>
        ),
        size: 200,
      },
    ],
    [],
  );

  const startCountdown = () => {
    if (!isCounting) {
      setTimeLeft(_timerDelayClick);
      setIsCounting(true);
    }
  };

  function getColorProcessingMethod(value: string) {
    switch (value) {
      case "Xử lý tại nhà":
        return "lime";
      case "Hãng xử lý":
        return "green";
      case "Xử ý trực tiếp":
        return "teal";
      case "Xử lý tại CH/CN":
        return "cyan";
      case "Xử lý từ xa":
        return "orange";
    }
  }

  const optionColorPD: Record<
    "Quá hạn" | "Chưa đến hạn" | "Sắp đến hạn" | "Đã trả khách",
    string
  > = {
    "Chưa đến hạn": "blue",
    "Quá hạn": "red",
    "Sắp đến hạn": "yellow",
    "Đã trả khách": "green",
  };

  const renderSelectOptionPD: SelectProps["renderOption"] = ({
    option,
    checked,
  }) => (
    <Group flex="1" gap="xs">
      <Badge
        color={
          optionColorPD[
            option.label as
              | "Quá hạn"
              | "Chưa đến hạn"
              | "Sắp đến hạn"
              | "Đã trả khách"
          ]
        }
        radius="sm"
        variant="filled"
      >
        {option.label}
      </Badge>
      {checked && (
        <IconCheck size={"14px"} style={{ marginInlineStart: "auto" }} />
      )}
    </Group>
  );

  const optionColorsAccount: Record<
    | "Xử lý tại nhà"
    | "Hãng xử lý"
    | "Xử lý tại chỗ"
    | "Xử lý tại CH/CN"
    | "Xử lý từ xa",
    string
  > = {
    "Xử lý tại nhà": "lime",
    "Hãng xử lý": "green",
    "Xử lý tại chỗ": "teal",
    "Xử lý tại CH/CN": "cyan",
    "Xử lý từ xa": "orange",
  };

  const renderSelectOptionStatus: SelectProps["renderOption"] = ({
    option,
    checked,
  }) => (
    <Group flex="1" gap="xs">
      <Badge
        color={
          optionColorsAccount[
            option.label as
              | "Xử lý tại nhà"
              | "Hãng xử lý"
              | "Xử lý tại chỗ"
              | "Xử lý tại CH/CN"
              | "Xử lý từ xa"
          ]
        }
        radius="sm"
        variant="filled"
      >
        {option.label}
      </Badge>
      {checked && (
        <IconCheck size={"14px"} style={{ marginInlineStart: "auto" }} />
      )}
    </Group>
  );

  const handleChangeSearchValue = (value: string, key: string) => {
    setSearch((prevData: any) => ({ ...prevData, [key]: value }));
  };

  const getDaysDifference = (dateString: string) => {
    const givenDate = new Date(dateString);
    const currentDate = new Date();

    const timeDifference = currentDate.getTime() - givenDate.getTime();

    const dayDifference = Math.floor(timeDifference / (1000 * 60 * 60 * 24));

    return dayDifference;
  };

  const fetchData = async () => {
    setIsLoading(true);
    setIsRefetching(true);
    setIsError(false);

    let url = `?Skip=${pagination?.pageIndex * pagination?.pageSize}&Take=${
      pagination.pageSize
    }`;

    if (search.startDate.length > 0) {
      url += `&StartDate=${search.startDate}`;
    }

    if (search.endDate.length > 0) {
      url += `&EndDate=${search.endDate}`;
    }

    if (search.processingMethod.length > 0) {
      url += `&ProcessingMethod=${search.processingMethod}`;
    }

    if (search.customerGroup.length > 0) {
      url += `&CustomerGroup=${search.customerGroup}`;
    }

    if (search.branch.length > 0) {
      url += `&BranchCode=${search.branch}`;
    }

    if (fromValue.current > 0) {
      url += `&FromValue=${fromValue.current}`;
    }

    if (toValue.current > 0) {
      url += `&ToValue=${toValue.current}`;
    }

    if (search.outDate.length > 0) {
      url += `&OutDate=${search.outDate}`;
    }
    if (search.itemStatus.length > 0) {
      url += `&ItemStatus=${search.itemStatus}`;
    }

    if (keySearch.length > 0) {
      url += `&KeySearch=${keySearch}`;
    }

    try {
      const response = await repositoryMdm.get(
        `/api/v1/TblWarrantyServiceRequestForm/get-list-report${url}`,
      );
      if (response && response.success) {
        let result = response.data;
        setData(result);
        setRowCount(response.totalCount ?? 0);
        setSelectIds([]);
        table.resetRowSelection();
      }
    } catch (error) {
      setData([]);
      setIsError(true);
      console.error(error);
      return;
    } finally {
      setIsLoading(false);
      setIsRefetching(false);
      sessionStorage.setItem(
        String(location.pathname),
        JSON.stringify({
          ...search,
          keySearch: keySearch,
        }),
      );
    }
    startCountdown();
  };

  const handleExportData = async () => {
    open();
    try {
      let url = `/api/v1/TblWarrantyServiceRequestForm/export-handle-warranty?Skip=${
        pagination?.pageIndex * pagination?.pageSize
      }&Take=${pagination.pageSize}`;

      if (search.startDate.length > 0) {
        url += `&StartDate=${search.startDate}`;
      }

      if (search.endDate.length > 0) {
        url += `&EndDate=${search.endDate}`;
      }

      if (search.processingMethod.length > 0) {
        url += `&ProcessingMethod=${search.processingMethod}`;
      }

      if (search.customerGroup.length > 0) {
        url += `&CustomerGroup=${search.customerGroup}`;
      }

      if (search.branch.length > 0) {
        url += `&BranchCode=${search.branch}`;
      }

      if (fromValue.current > 0) {
        url += `&FromValue=${fromValue.current}`;
      }

      if (toValue.current > 0) {
        url += `&ToValue=${toValue.current}`;
      }

      if (search.outDate.length > 0) {
        url += `&OutDate=${search.outDate}`;
      }
      if (search.itemStatus.length > 0) {
        url += `&ItemStatus=${search.itemStatus}`;
      }
      if (keySearch.length > 0) {
        url += `&KeySearch=${keySearch}`;
      }

      const _url = BASE_API_MDM + url;
      const token = localStorage.getItem("token");

      const response = await fetch(_url, {
        method: "GET",
        headers: {
          "Content-Type": "application/vnd.ms-excel",
          Authorization: `Bearer ${token?.replace(`"`, "").replace(`"`, "")}`,
        },
      });

      if (!response.ok) {
        NotificationExtension.Fails("Export Excel thất bại !");
      } else {
        const blob = await response.blob();
        const urlss = window.URL.createObjectURL(blob);
        const _name = new Date().toISOString().slice(0, 10);
        let filename = "bao_cao_thuc_hien_xu_ly_yeu_cau" + _name + ".xlsx";
        const link = document.createElement("a");
        link.href = urlss;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
        NotificationExtension.Success("Export Excel thành công !");
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      close();
    }
  };

  const dataBranchSelect = async () => {
    const getData = await getBranchSelectMdm();
    setDataTblBranch(
      getData
        ?.filter(
          (item) =>
            item.att2 != null && item.text != null && item.value != "-1",
        )
        ?.map((item) => ({
          value: item.att2?.toString(),
          label: item.text,
        })),
    );
  };

  const dataProcessingMethodSelect = async () => {
    try {
      const getData = await getTblDmProcessingMethodSelect();
      const filteredData = getData
        ?.filter((item) => item.value != null && item.text != null)
        ?.map((item) => ({
          label: item.text,
          value: item.value?.toString(),
        }));
      setDataTblProcessingMethod(filteredData);
    } catch (error) {
      console.error("Error in dataTblLocation: ", error);
    }
  };

  const getDataWarrantyCustomerGroup = async () => {
    const res = await repositoryMdm.get<MessageResponse<any>>(
      "/api/v1/TblWarrantyCustomerGroup/get-all",
    );

    if (res && res?.success) {
      const getData = res.data;
      const filteredData = getData?.filter(
        (item: any) => item.text != null && item.value != null,
      );
      const mappedData = filteredData?.map((item: any) => ({
        value: item.value?.toString(),
        label: item.text,
      }));
      setDataWarrantyCustomerGroup(mappedData);
    }
  };

  useEffect(() => {
    let timer: ReturnType<typeof setInterval>;
    if (isCounting && timeLeft > 0) {
      timer = setInterval(() => {
        setTimeLeft((prevTime) => prevTime - 1);
      }, 1000);
    } else if (timeLeft === 0) {
      setIsCounting(false);
    }
    return () => clearInterval(timer);
  }, [isCounting, timeLeft]);

  useEffect(() => {
    const valuesList = Object.keys(rowSelection);
    setSelectIds(valuesList);
    if (valuesList.length < 1) setSelectIds([]);
    else {
      const valuesList = Object.keys(rowSelection);
      setSelectIds(valuesList);
    }
  }, [rowSelection]);

  useEffect(() => {
    dataBranchSelect();
    dataProcessingMethodSelect();
    getDataWarrantyCustomerGroup();
  }, []);

  useEffect(() => {
    fetchData();
  }, [pagination, deleteViewStatus]);

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      // 160 là chiều cao của phần phân trang
      // headerHeight là chiều cao của phần header
      setHeight(window.innerHeight - (140 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize); // Update height on window resize

    return () => {
      window.removeEventListener("resize", handleResize); // Clean up event listener
    };
  }, [height]);

  const getColumnPinningStorage = () => {
    const columnPinningStorage = localStorage.getItem(
      "columnPinningRequestFormReport",
    );
    return columnPinningStorage
      ? JSON.parse(columnPinningStorage)
      : {
          right: ["action"],
        }; // Giá trị mặc định
  };

  // Lưu columnPinning vào state
  const [columnPinning, setColumnPinning] = useState<ColumnPinningType>(
    getColumnPinningStorage(),
  );

  // Hàm lưu vào localStorage
  useEffect(() => {
    localStorage.setItem(
      "columnPinningRequestFormReport",
      JSON.stringify(columnPinning),
    );
  }, [columnPinning]);

  const table = useMantineReactTable({
    columns,
    data,
    enableColumnResizing: true,
    enableColumnFilters: false,
    enableSorting: false,
    enableColumnActions: true,
    positionToolbarAlertBanner: "bottom",
    //add custom action buttons to top-left of top toolbar
    renderTopToolbarCustomActions: ({ table }) => (
      <div ref={headerRef} style={{ width: "100%" }}>
        <Flex wrap={"wrap"} justify={"space-between"}>
          <_breadcrumb></_breadcrumb>
          <Flex gap={"sm"} align={"center"} wrap={"wrap"}>
            <Badge color="red" />
            <Text fw={500} size="12.5px">
              Quá hạn
            </Text>
            <Badge color="blue" />
            <Text fw={500} size="12.5px">
              Chưa đến hạn
            </Text>
            <Badge color="yellow" />
            <Text fw={500} size="12.5px">
              Sắp đến hạn
            </Text>
            <Badge color="green" />
            <Text fw={500} size="12.5px">
              Đã trả khách
            </Text>
          </Flex>
          <Button
            leftSection={
              <IconFileExport style={{ width: rem(14), height: rem(14) }} />
            }
            onClick={() => handleExportData()}
          >
            Export Excel
          </Button>
        </Flex>
        <Grid mt={10}>
          <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
            <DatePickerInput
              size="sm"
              placeholder="Từ ngày"
              leftSection={<IconCalendar color="#15aabf" />}
              locale="vi"
              valueFormat="DD/MM/YYYY"
              value={
                search.startDate && search.startDate.length > 0
                  ? new Date(search.startDate)
                  : null
              }
              maxDate={
                search.endDate && search.endDate?.length > 0
                  ? new Date(search.endDate)
                  : new Date()
              }
              onChange={(e) => {
                handleChangeSearchValue(
                  formatDateNotTimeZone(e) ?? "",
                  "startDate",
                );
              }}
              clearable
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
            <DatePickerInput
              size="sm"
              placeholder="Đến ngày"
              leftSection={<IconCalendar color="#15aabf" />}
              locale="vi"
              valueFormat="DD/MM/YYYY"
              value={
                search.endDate && search.endDate.length > 0
                  ? new Date(search.endDate)
                  : null
              }
              minDate={
                search.startDate && search.startDate?.length > 0
                  ? new Date(search.startDate)
                  : undefined
              }
              onChange={(e) => {
                handleChangeSearchValue(
                  formatDateNotTimeZone(e) ?? "",
                  "endDate",
                );
              }}
              clearable
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
            <Select
              placeholder="Chi nhánh"
              value={search.branch || null}
              searchable
              clearable
              data={dataTblBranch}
              leftSection={
                <IconBrandBootstrap size={20} style={{ color: teal.base }} />
              }
              onChange={(e) =>
                handleChangeSearchValue(e?.toString() ?? "", "branch")
              }
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
            <Select
              placeholder="Hình thức xử lý"
              value={search.processingMethod || null}
              type="text"
              w={"100%"}
              clearable
              searchable
              leftSection={
                <IconLocationFilled
                  size={20}
                  style={{ color: teal.base }}
                ></IconLocationFilled>
              }
              comboboxProps={{
                transitionProps: { transition: "pop", duration: 200 },
              }}
              data={dataTblProcessingMethod}
              onChange={(e) => {
                handleChangeSearchValue(
                  e?.toString() ?? "",
                  "processingMethod",
                );
              }}
              renderOption={renderSelectOptionStatus}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
            <Select
              placeholder="Nhóm khách hàng"
              value={search.customerGroup || null}
              data={dataWarrantyCustomerGroup}
              searchable
              clearable
              leftSection={<IconUsers size={20} style={{ color: teal.base }} />}
              onChange={(e) => {
                handleChangeSearchValue(e?.toString() ?? "", "customerGroup");
              }}
              nothingFoundMessage="Không tìm thấy dữ liệu !"
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
            <Select
              placeholder="Hạn xử lý"
              value={search.outDate || null}
              data={[
                { label: "Chưa đến hạn", value: "CHUA_DEN_HAN" },
                { label: "Sắp đến hạn", value: "SAP_DEN_HAN" },
                { label: "Quá hạn", value: "QUA_HAN" },
                { label: "Đã trả khách", value: "DA_TRA_KHACH" },
              ]}
              leftSection={
                <IconCalendarCog size={20} style={{ color: teal.base }} />
              }
              onChange={(e) => {
                handleChangeSearchValue(e?.toString() ?? "", "outDate");
              }}
              renderOption={renderSelectOptionPD}
            />
          </Grid.Col>
        </Grid>
        <Grid>
          <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
            <NumberInput
              placeholder="Số ngày tiếp nhận (Từ n ngày)"
              hideControls
              allowNegative={false}
              suffix=" ngày"
              leftSection={
                <IconCalendarUp size={20} style={{ color: teal.base }} />
              }
              onChange={(e) => {
                fromValue.current = Number(e);
              }}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
            <NumberInput
              placeholder="Số ngày tiếp nhận (Đến n ngày)"
              hideControls
              allowNegative={false}
              suffix=" ngày"
              leftSection={
                <IconCalendarDown size={20} style={{ color: teal.base }} />
              }
              onChange={(e) => {
                toValue.current = Number(e);
              }}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
            <Select
              placeholder="Trạng thái xử lý"
              value={search.itemStatus || null}
              data={[
                { value: "NHAP_KHO", label: "Nhập kho" },
                { value: "TRA_KHACH", label: "Trả khách" },
              ]}
              leftSection={
                <IconAdjustmentsHorizontal
                  size={20}
                  style={{ color: teal.base }}
                />
              }
              onChange={(e) => {
                handleChangeSearchValue(e?.toString() ?? "", "itemStatus");
              }}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
            <TextInput
              placeholder="Nhập từ khóa"
              defaultValue={keySearch}
              leftSection={<IconSearch color="#15aabf" />}
              onChange={(e) => setKeySearch(e.currentTarget.value)}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 6, lg: 1 }}>
            <Button
              leftSection={<IconSearch size={14} />}
              color="blue"
              variant="outline"
              onClick={() => {
                fetchData();
              }}
            >
              Tìm kiếm
            </Button>
          </Grid.Col>
        </Grid>
      </div>
    ),
    renderToolbarInternalActions: ({ table }) => <></>,
    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },
    localization: _localization,
    enableRowSelection: false,
    getRowId: (row) => row.id,
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        ...columnPinning,
      },
      columnVisibility: { id: false },
      density: "xs",
    },
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    onColumnPinningChange: (newState) => {
      setColumnPinning(newState);
    },
    onRowSelectionChange: setRowSelection,
    manualFiltering: false,
    manualPagination: true,
    manualSorting: false,
    rowCount,
    onPaginationChange: setPagination,
    mantineTableBodyCellProps: ({ row }) => ({
      style: {
        fontWeight: "500",
        fontSize: "12.5px",
        padding: "5px 15px",
      },
    }),
    state: {
      isLoading,
      pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading,
      rowSelection,
      columnPinning,
    },
    mantineToolbarAlertBannerProps: isError
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      rowsPerPageOptions: ["25", "50", "100"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
    columnFilterDisplayMode: "popover",
  });

  return (
    <Box pos="relative">
      <LoadingOverlayCustom visible={visible} />
      <MantineReactTable table={table} />
    </Box>
  );
};

export default RequestFormReport;
